import { render, staticRenderFns } from "./Precatity.vue?vue&type=template&id=1211425c&scoped=true&"
import script from "./Precatity.vue?vue&type=script&lang=js&"
export * from "./Precatity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1211425c",
  null
  
)

export default component.exports